﻿if (!customElements.get('feature-product-dev')) {
  const decodeHtml = (value) => {
    if (!value) return '';
    const el = document.createElement('textarea');
    el.innerHTML = value;
    return el.value;
  };

  const normColor = (value) => decodeHtml(String(value || '')).toLowerCase().trim();

  const waitForSlick = (callback) => {
    if (typeof $ !== 'undefined' && $.fn.slick) callback();
    else setTimeout(() => waitForSlick(callback), 50);
  };

  class FeatureProductDev extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.slider = this.querySelector('.js-feature-slider');
      this.form = this.querySelector('form[action*="/cart/add"]');

      const jsonEl = this.querySelector('script[type="application/json"]');
      this.productData = jsonEl ? JSON.parse(jsonEl.textContent) : null;

      const wrapper = this.querySelector('.js-product-form');
      this.colorOptionIndex = parseInt(wrapper?.dataset.colorOptionIndex ?? '-1', 10);
      if (this.colorOptionIndex < 0) {
        const swatch = this.querySelector('.option-selector--swatch');
        if (swatch) this.colorOptionIndex = parseInt(swatch.dataset.optionIndex ?? '-1', 10);
      }

      this.originalSlides = null;
      this.lastWidth = window.innerWidth;
      this._onVariantChange = this.onVariantChange.bind(this);
      this._onColorClick = this.onColorClick.bind(this);

      if (this.productData && this.slider) {
        this.initSlider();
        this.bindEvents();
      }

      this.mobileModal = this.querySelector('.js-mobile-variant-modal');
      this.mobileModalOpenBtn = this.querySelector('.js-mobile-modal-open');
      this.mobileModalCloseBtns = this.querySelectorAll('.js-mobile-modal-close');

      if (this.mobileModalOpenBtn && this.mobileModal) {
        this.mobileModalOpenBtn.addEventListener('click', () => {
          this.mobileModal.classList.add('is-open');
        });
      }

      if (this.mobileModalCloseBtns && this.mobileModal) {
        this.mobileModalCloseBtns.forEach(btn => {
          btn.addEventListener('click', () => {
            this.mobileModal.classList.remove('is-open');
          });
        });
      }

      this.mobileModalSubmitBtn = this.querySelector('.js-mobile-modal-submit-trigger');
      this.mainAddToCartBtn = this.querySelector('.js-main-add-to-cart-btn');

      if (this.mobileModalSubmitBtn && this.mainAddToCartBtn) {
        this.mobileModalSubmitBtn.addEventListener('click', () => {
          if (this.mobileModal) {
            this.mobileModal.classList.remove('is-open');
          }
          this.mainAddToCartBtn.click();
        });
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onColorClick, true);
      this.removeEventListener('change', this._onVariantChange);
    }

    isColorSelector(selector) {
      if (!selector) return false;
      if (selector.classList.contains('option-selector--swatch')) return true;
      return (
        this.colorOptionIndex >= 0 &&
        parseInt(selector.dataset.optionIndex, 10) === this.colorOptionIndex
      );
    }

    isColorInput(input) {
      return this.isColorSelector(input?.closest('.option-selector'));
    }

    colorFrom(input) {
      return input?.getAttribute('data-color') || input?.value || '';
    }

    getCheckedColorInput() {
      if (this.colorOptionIndex >= 0) {
        const input = this.querySelector(
          `.option-selector[data-option-index="${this.colorOptionIndex}"] .opt-btn.js-option:checked`
        );
        if (input) return input;
      }
      return this.querySelector('.option-selector--swatch .opt-btn.js-option:checked');
    }

    getOptionsFromForm() {
      return Array.from(this.querySelectorAll('.option-selector')).map((fieldset) => {
        if (fieldset.dataset.selectorType === 'dropdown') {
          return decodeHtml(fieldset.querySelector('select')?.value || '');
        }
        return decodeHtml(fieldset.querySelector('input[type="radio"]:checked')?.value || '');
      });
    }

    getVariant(options) {
      return this.productData.variants.find((variant) =>
        options.every((option, index) => option === variant.options[index])
      );
    }

    getFeaturedMediaId(color) {
      const normalized = normColor(color);
      const variant = this.productData.variants.find(
        (v) => normColor(v.options[this.colorOptionIndex]) === normalized && v.featured_media
      );
      return variant?.featured_media?.id ?? null;
    }

    mapSlideColors() {
      if (!this.originalSlides || this.colorOptionIndex < 0) return;

      const mediaByOption = {};
      this.productData.variants.forEach((variant) => {
        const optionName = variant.options[this.colorOptionIndex];
        if (variant.featured_media && optionName && !mediaByOption[optionName]) {
          mediaByOption[optionName] = variant.featured_media.id;
        }
      });

      let currentColor = '';
      this.originalSlides.each(function () {
        const mediaId = parseInt($(this).attr('data-media-id'), 10);
        for (const optionName in mediaByOption) {
          if (mediaId === parseInt(mediaByOption[optionName], 10)) currentColor = optionName;
        }
        $(this).attr('data-color', currentColor);
      });
    }

    initSlick() {
      waitForSlick(() => {
        const $slider = $(this.slider);
        const transition = $slider.data('transition') || 'slide';
        const isDesktop = window.innerWidth >= 768;

        const autoplayDesktop = $slider.data('autoplay-desktop') === true;
        const speedDesktop = (parseInt($slider.data('speed-desktop'), 10) || 28) * 1000;

        const autoplayMobile = $slider.data('autoplay-mobile') === true;
        const speedMobile = (parseInt($slider.data('speed-mobile'), 10) || 28) * 1000;

        $slider
          .off('init.featureProductDev')
          .on('init.featureProductDev', function () {
            $(this).find('.lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');
          })
          .slick({
            autoplay: autoplayDesktop,
            fade: transition === 'fade' && !isDesktop,
            speed: autoplayDesktop && transition !== 'fade' ? speedDesktop : 800,
            autoplaySpeed: autoplayDesktop && transition !== 'fade' ? 0 : speedDesktop,
            cssEase: autoplayDesktop && transition !== 'fade' ? 'linear' : 'ease',
            arrows: false,
            dots: true,
            pauseOnHover: false,
            infinite: true,
            useTransform: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  fade: transition === 'fade',
                  autoplay: autoplayMobile,
                  speed: (autoplayMobile && transition !== 'fade') ? speedMobile : 800,
                  autoplaySpeed: (autoplayMobile && transition !== 'fade') ? 0 : speedMobile,
                  cssEase: (autoplayMobile && transition !== 'fade') ? 'linear' : 'ease'
                },
              },
            ],
          });
      });
    }

    filterSlider(color) {
      if (!this.slider) return;

      waitForSlick(() => {
        const $slider = $(this.slider);

        if (!this.originalSlides) {
          this.originalSlides = $slider.find('.js-slide-item').clone();
          this.mapSlideColors();
        }

        if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');

        $slider.removeClass('layout-1-col layout-2-col layout-3-col').empty();

        const selected = normColor(color);
        const featuredId = this.getFeaturedMediaId(color);
        const matches = [];

        this.originalSlides.each(function () {
          const $slide = $(this);
          const slideColor = normColor($slide.attr('data-color'));
          const mediaId = parseInt($slide.attr('data-media-id'), 10);
          const show =
            !selected ||
            slideColor === selected ||
            (featuredId && mediaId === featuredId);

          if (show) matches.push($slide.clone());
        });

        if (!matches.length) {
          this.originalSlides.each(function () {
            matches.push($(this).clone());
          });
        }

        matches.forEach(($slide) => $slider.append($slide));

        const minSlides = window.innerWidth >= 768 ? 6 : 2;
        let i = 0;
        while ($slider.find('.js-slide-item').length < minSlides && matches.length) {
          $slider.append(matches[i++ % matches.length].clone());
        }

        this.initSlick();
      });
    }

    goToFeaturedSlide(mediaId) {
      if (!mediaId || !this.slider) return;

      waitForSlick(() => {
        const $slider = $(this.slider);
        if (!$slider.hasClass('slick-initialized')) return;

        const $target = $slider
          .find(`.js-slide-item:not(.slick-cloned)[data-media-id="${mediaId}"]`)
          .first();
        if (!$target.length) return;

        const slickIndex = $target.attr('data-slick-index');
        const index =
          slickIndex !== undefined
            ? parseInt(slickIndex, 10)
            : $slider.find('.js-slide-item:not(.slick-cloned)').index($target);

        if (index >= 0) $slider.slick('slickGoTo', index, true);
      });
    }

    updateSliderForColor(color) {
      if (!color) return;
      this.filterSlider(color);
      const mediaId = this.getFeaturedMediaId(color);
      if (mediaId) this.goToFeaturedSlide(mediaId);
    }

    refreshSlider() {
      const input = this.getCheckedColorInput();
      const color = input ? this.colorFrom(input) : '';
      color ? this.updateSliderForColor(color) : this.filterSlider('');
    }

    initSlider() {
      this.refreshSlider();

      const variant = this.getVariant(this.getOptionsFromForm());
      if (variant?.featured_media) this.goToFeaturedSlide(variant.featured_media.id);

      window.addEventListener('resize', () => {
        if (Math.abs(window.innerWidth - this.lastWidth) <= 20) return;
        this.lastWidth = window.innerWidth;
        this.refreshSlider();
      });
    }

    onColorClick(event) {
      const selector = (event.target.closest('.opt-btn.js-option') || event.target.closest('.opt-label'))
        ?.closest('.option-selector');
      if (!this.isColorSelector(selector)) return;

      const run = () => {
        const input = selector.querySelector('.opt-btn.js-option:checked');
        if (input) this.updateSliderForColor(this.colorFrom(input));
      };

      event.target.closest('.opt-btn.js-option') ? run() : setTimeout(run, 0);
    }

    bindEvents() {
      this.addEventListener('click', this._onColorClick, true);
      this.addEventListener('change', this._onVariantChange);
    }

    onVariantChange(event) {
      if (!event.target.matches('input[type="radio"], select')) return;

      const isColor = this.isColorInput(event.target);
      if (isColor) this.updateSliderForColor(this.colorFrom(event.target));

      this.querySelectorAll('.choose_size-popup.desktop-only').forEach((trigger) => {
        const colorInput = this.getCheckedColorInput();
        if (colorInput) trigger.setAttribute('data-option-selected', colorInput.value);
      });

      const formOptions = this.getOptionsFromForm();
      const variant = this.getVariant(formOptions);
      if (!variant) return;

      // Update option labels
      const optionSelectors = this.querySelectorAll('.option-selector');
      optionSelectors.forEach((selector, index) => {
        const val = formOptions[index];
        if (val) {
          const label = selector.querySelector('.selected-option-name');
          if (label) {
            label.textContent = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
          }
        }
      });

      const detailBtn = this.querySelector('.btn-detail-sec');
      if (detailBtn) {
        const urlObj = new URL(detailBtn.href, window.location.origin);
        urlObj.searchParams.set('variant', variant.id);
        detailBtn.href = urlObj.toString();
      }

      if (!isColor && variant.featured_media) {
        this.goToFeaturedSlide(variant.featured_media.id);
      }
    }

  }

  customElements.define('feature-product-dev', FeatureProductDev);
}
